import React from 'react';
import { Route, Switch } from 'react-router';

import NotFound from '@swf/components/StarsModal/NotFound';

import PresentationalSizesModal from '../../storybook/PresentationalSizes/PresentationalSizes';
import { ModalPath } from '../../types/common';

import ActiveTableLimitModal from './ActiveTableLimit/ActiveTableLimit';

const ModalRoutes: React.FC = () => (
  <Switch>
    <Route path={ModalPath.ActiveTableLimit} component={ActiveTableLimitModal} />
    <Route path={ModalPath.PresentationalSizes} component={PresentationalSizesModal} />
    <Route component={NotFound} />
  </Switch>
);

export default ModalRoutes;
